import { jsxs, jsx } from 'react/jsx-runtime';
import { isMobile, CustomLink, Slider, SubTitle, Caption, styled } from '@teko/ds-desktop';
import { defaultSlider } from './constants.es.js';
import { g as getTrackingData } from './tracking-3282e302.js';
import { t } from './i18n.es.js';
import { B as BlockHeader } from './BlockHeader-4332d564.js';
import { E as EnhancedImage } from './EnhancedImage-5956213c.js';

const FeaturedBrands = ({ header, brands, slider = Object.assign(Object.assign({}, defaultSlider), { slidesPerView: 4 }), }) => {
    if (!brands || !brands.length)
        return null;
    return (jsxs(Wrapper, { children: [jsx(BlockHeader, Object.assign({}, header, { title: header.title || t('Thương hiệu nổi bật') }), void 0), isMobile && (jsx(MobileSliderWrapper, { children: brands.map((brand, index) => (jsx(MobileSliderItem, Object.assign({ slidesPerView: slider.slidesPerView }, getTrackingData({
                    index,
                    regionName: 'topBrands',
                    target: brand === null || brand === void 0 ? void 0 : brand.link.href,
                    contentName: brand === null || brand === void 0 ? void 0 : brand.name,
                    isTrackContent: true,
                }), { children: jsx(CustomLink, Object.assign({}, brand.link, { children: jsx(EnhancedImage, Object.assign({}, brand.image, { googleImageParams: {
                                width: 400,
                            }, hover: "zoom", borderRadius: 8, objectFit: "cover", height: 120 }), void 0) }), void 0) }), index))) }, void 0)), !isMobile && (jsx(SliderWrapper, { children: jsx(Slider, Object.assign({}, slider, { children: brands.map((brand, index) => (jsx(CustomLink, Object.assign({}, brand.link, { children: jsxs(Card, Object.assign({}, getTrackingData({
                            index,
                            regionName: 'topBrands',
                            target: brand === null || brand === void 0 ? void 0 : brand.link.href,
                            contentName: brand === null || brand === void 0 ? void 0 : brand.name,
                            isTrackContent: true,
                        }), { children: [jsx(EnhancedImage, Object.assign({}, brand.image, { googleImageParams: {
                                        width: 400,
                                    }, hover: "zoom", borderRadius: 8, objectFit: "cover", height: 140 }), void 0), jsx(SubTitle, Object.assign({ level: 2, line: 1, marginTop: "s16" }, { children: brand.name }), void 0), brand.description && (jsx(Caption, Object.assign({ level: 1, weight: "regular", line: 1 }, { children: brand.description }), void 0))] }), void 0) }), index))) }), void 0) }, void 0))] }, void 0));
};
const Wrapper = styled.div `
  background: white;
  border-radius: 8px;
`;
const Card = styled.div `
  text-align: center;
`;
const SliderWrapper = styled.div `
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
`;
const MobileSliderWrapper = styled.div `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  transform: translate3d(0, 0, 0);
`;
const MobileSliderItem = styled.div(({ slidesPerView }) => `
  width: ${100 / slidesPerView}%;
  flex-shrink: 0;
  margin-right: 16px;
`);

export { FeaturedBrands as F };
